import {FC, Fragment, ReactElement} from 'react';
import {Empty} from 'antd';
import { useLabels } from '../hooks/Labels';
import { Typography } from 'antd';

const {Title, Paragraph} = Typography;

export const NotEnoughUsage: FC = (): ReactElement => {
    const {t} = useLabels();
    return (
        <div style={{marginTop: '10%', width: '100%'}}>
            <Empty
                image={Empty.PRESENTED_IMAGE_DEFAULT}
                description={
                    <Fragment>
                        <Title style={{fontSize: '1.2rem'}}>
                            {t('analytics_not_available_title')}
                        </Title>
                        <Paragraph>
                            {t('analytics_not_available_explanation')}
                        </Paragraph>
                        <Paragraph>
                            {t('analytics_not_available_explanation_extra')}
                        </Paragraph>
                    </Fragment>
                }
            />
        </div>
    )
};
